export const NODE_ENV = process.env.NODE_ENV;
export const PUBLIC_URL = process.env.PUBLIC_URL;
export const IS_DEV_MODE = NODE_ENV !== 'production';
export const IS_PRODUCTION = NODE_ENV === 'production';
